import request from '@/utils/request';

/**
 * 获取支付通道枚举下拉框
 */
export function getPayChannelOption() {
  return request({
    url: '/admin/payChannel/getPayChannelOption',
    method: 'get'
  });
}

/**
 * 新增支付通道配置
 * @param data
 */
export function addPayChannel(data) {
  return request({
    url: '/admin/payChannel/add',
    method: 'post',
    data: data
  });
}

/**
 * 编辑支付通道配置
 * @param data
 */
export function updatePayChannel(data) {
  return request({
    url: '/admin/payChannel/update',
    method: 'post',
    data: data
  });
}

/**
 * 支付通道配置详情
 * @param id
 */
export function getPayChannelInfo(id) {
  return request({
    url: '/admin/payChannel/info',
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 根据小程序ID获取支付通道配置列表
 * @param companyAppId
 */
export function listByApp(companyAppId) {
  return request({
    url: '/admin/payChannel/listByApp',
    method: 'get',
    params: {
      companyAppId: companyAppId
    }
  });
}